<script setup lang="ts">
import ModalInMiddle from '@/components/Modal/ModalInMiddle.vue';
import _service from '@/service';
import { useConfigStore } from '@/stores/config';
import { closeToast, showLoadingToast, showToast } from 'vant';
import { ref } from 'vue';
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
const {t} = useI18n()
const showDeleteModal = ref<boolean>(false)
const deleteIdx = ref<any>(0)
const addressList = ref<any>([])
const countryOriginList = ref<any>([])

const configStore = useConfigStore()

const getAddressList = async ()=> {
  try {
    showLoadingToast({
      message: t("Loading"),
      duration: 0,
    });
    const {data} = await _service.getAddressList({})
    data.map((item:any)=>{
      item.countryText = countryOriginList.value.filter((item2:any)=>{
        return item2.code === item.country
      })[0].label
    })
    closeToast()
    if (data.length) {
      addressList.value = data
    }else{
      addressList.value = []
    }
    closeToast()
  } catch (error) {
    showToast(`${error}`)
  }
}

const setDefault = async (item:any) => {
  if (!item.isDefault) {
    await _service.updateAddress({
      ...item,
      isDefault:true
    })
    getAddressList()
  }
  
}

const deleteAddress = async() => {
  const idx = deleteIdx.value
  
 try {
  const {data} = await _service.deleteAddressById({id:addressList.value[idx].id})
  if (data) {
    showToast(t('Deleted'))
    if (addressList.value[idx].isDefault && idx !== 0) {
      setDefault(addressList.value[0])
    }else{
      setDefault(addressList.value[1])
    }
    getAddressList()
    showDeleteModal.value = false
  }
 } catch (error) {
  showToast(`${error}`)
  getAddressList()
 }
}

const handleDelete = (idx:number) => {
  deleteIdx.value = idx
  showDeleteModal.value = true
}

onMounted(async()=>{
  console.log(configStore.getCounrtryList);
  
  if (!configStore.getCounrtryList.length) {
    countryOriginList.value = await configStore.getOriginCountry()
  }
  countryOriginList.value = configStore.getCounrtryList
  getAddressList()
})
</script>

<template>
  <div class="address-list">
    <div class="media-375">
      <div class="list-wrapper flex-col-center-center">
        <div class="list-item" v-for="(item,index) in addressList" :key="item.id">
          <div class="row flex-row-between-center">
            <span class="name">{{item.firstName}} {{item.lastName}}</span>
            <span class="phone number-font">{{ item.phone }}</span>
          </div>
          <div class="addr flex-col-start-start">
            <span class="area">{{item.countryText}} {{item.state}} {{item.city}}</span>
            <span class="address">{{item.address1}}</span>
          </div>
          <div class="border-line"></div>
          <div class="tool-bar flex-row-between-center">
            <div class="default flex-row-start-center" @click="setDefault(item)">
              <span class="checked" :class="{'non-checked':!item.isDefault}"></span> Default
            </div>
            <div class="right flex-row-start-center">
              <router-link :to="`/new-address/${item.id}`" class="edit"></router-link>
              <span class="delete" @click="handleDelete(index)"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="for-bottom-area"></div>
      <div class="bottom-area media-375-fixed">
        <router-link to="/new-address" class="bottom-btn">{{t('New address')}}</router-link>
      </div>
    </div>
    <ModalInMiddle v-model:isShow="showDeleteModal" :title="t('Delete address')">
      <div class="confirm-modal">
        <div class="ct">{{t('Are you sure you want to delete this address?')}}</div>
        <div class="btn-group flex-row-between-center">
          <div class="btn gray flex-row-center-center"  @click="deleteAddress">{{t('Confirm')}}</div>
          <div class="btn flex-row-center-center" @click="showDeleteModal = false">{{t('Cancel')}}</div>
        </div>
      </div>
    </ModalInMiddle>
  </div>
</template>

<style lang="scss" scoped>
.address-list{
  height: 100%;
  min-height: 100vh;
  background: #070B14;
  padding: 0 12px;
  padding-top: 16px;
  .list-wrapper{
    gap: 12px;
    .list-item{
      width: 100%;
      display: flex;
      padding: 16px;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      border-radius: 12px;
      background:  #303342;
      color: #fff;
      .row{
        width: 100%;
        font-size: 16px;
        font-weight: 600;
      }
      .addr{
        width: 100%;
        gap: 4px;
        .area{
          font-size: 12px;
          font-weight: 400;
          color: #9C9CAA;
          line-height: 16px;
        }
        .address{
          width: 100%;
          line-height: 18px;
          font-weight: 600;
          @include ellipsis;
        }
      }
      .border-line{
        width: 100%;
        height: 1px;
        background-color: #545769;
      }
      .tool-bar{
        width: 100%;
        .default{
          gap: 4px;
          .checked{
            width: 24px;
            height: 24px;
            background: url(../../assets/checked.svg);
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            &.non-checked{
              background: url(../../assets/non-checked.svg);
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center;
            }
          }
          font-size: 12px;
          font-weight: 400;
          color: #1CF2E4;
        }
        .right{
          gap: 16px;
          .edit{
            width: 16px;
            height: 16px;
            background: url(../../assets/edit.svg);
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
          }
          .delete{
            width: 16px;
            height: 16px;
            background: url(../../assets/delete.svg);
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }
    }
  }
}
</style>
